import {FieldType} from "../../fields3/field-type"
import FieldProto from "../../fields3/proto/field-proto"
import {Field1Type} from "../../fields/@const"

export function projectColumnToFieldFactory(type: string): FieldProto | null {
    switch(type) {
        case Field1Type.TASK_TYPE                       : return gd.fields.project.projectType
        case Field1Type.STATUS                          : return gd.fields.project.statusId
        case Field1Type.PRIORITY                        : return gd.fields.project.priority
        case Field1Type.OWNER                           : return gd.fields.project.projectOwner
        case Field1Type.USERS                           : return gd.fields.project.users
        case Field1Type.START_END_DATE                  : return gd.fields.project.startEnd
        case Field1Type.DEADLINE                        : return gd.fields.project.deadline
        case Field1Type.START_DATE                      : return gd.fields.project.startDate
        case Field1Type.END_DATE                        : return gd.fields.project.endDate
        case Field1Type.DATE_CREATED                    : return gd.fields.project.momentCreated
        case Field1Type.DURATION_CALENDAR_DAYS          : return gd.fields.project.durationCalendar
        case Field1Type.DURATION_WORK_DAYS              : return gd.fields.project.durationWorkdays

        case Field1Type.STORY_POINTS                    : return gd.fields.itemModel.calculatedStoryPoints
        case Field1Type.ESTIMATE                        : return gd.fields.itemModel.calculatedEstimated

        case Field1Type.TIME_REPORTED                   : return gd.fields.itemModel.calculatedTimeReports
        case Field1Type.SPENT_ESTIMATE                  : return gd.fields.itemModel.calculatedSpentEstimated
        case Field1Type.PROGRESS_BAR                    : return gd.fields.project.progress
        case Field1Type.PROGRESS_ITEMS                  : return gd.fields.project.progressItems

        case Field1Type.COST_EXPENSES                   :
        case FieldType.ITEM_MODEL_CALCULATED_EXPENSES   : return gd.fields.itemModel.calculatedExpenses

        case Field1Type.COST_INTERNAL                   : return gd.fields.itemModel.calculatedLaborCost
        case Field1Type.COST_EXTERNAL                   : return gd.fields.itemModel.calculatedServiceCost

        case FieldType.ESTIMATED_COST_INTERNAL          : return gd.fields.project.estimatedCostInternal
        case FieldType.ESTIMATED_COST_EXTERNAL          : return gd.fields.project.estimatedCostExternal

        case Field1Type.COMMENTS                        : return gd.fields.project.statusComments
        case Field1Type.OPEN_ALL                        : return gd.fields.project.totalOpenAll
        case Field1Type.PROJECT_COLOR                   : return gd.fields.project.color
        case Field1Type.PROJECT_HEALTH                  : return gd.fields.project.health

        case Field1Type.DEPENDS_ON                      : return gd.fields.project.predecessors
        case Field1Type.DEPENDANTS                      : return gd.fields.project.successors

        case FieldType.PROJECT_ESTIMATE                 : return gd.fields.project.estimate    // project own estimate
        case FieldType.PROJECT_ESTIMATE_TASKS           : return gd.fields.project.estimateTasks

        case FieldType.CRM_ACCOUNT                      : return gd.fields.project.crmAccountId
        case Field1Type.PROGRESS_PROJECT_TASKS          : return gd.fields.project.progressTasks
    }

    return null
}
